// extracted by mini-css-extract-plugin
export default {"navbar":"DXlCTPPkDyLshY1FxtQy","navbarLeft":"krFYQvp2600620pZVMhZ","navbarRight":"zwbIzLl7C2qSKE3TElen"};